module.exports = __webpack_public_path__ + "img/btn_menu_xg.e29e2418.png";